/**
 * Leads API: leads and calls captured from ads, across platforms.
 */
import apiClient from './api';
import type { Lead, LeadFilters, LeadStatus, LeadsSummary } from '@/types/leads';

const BASE = '/api/v1/analytics/leads';

export const leadsApi = {
  async list(filters: LeadFilters, limit = 50, offset = 0): Promise<{ leads: Lead[]; total: number }> {
    const { data } = await apiClient.get(BASE, { params: { ...filters, limit, offset } });
    return data;
  },

  async get(id: string): Promise<Lead> {
    const { data } = await apiClient.get(`${BASE}/${id}`);
    return data;
  },

  async summary(): Promise<LeadsSummary> {
    const { data } = await apiClient.get(`${BASE}/summary`);
    return data;
  },

  async update(id: string, patch: { status?: LeadStatus; notes?: string }): Promise<Lead> {
    const { data } = await apiClient.patch(`${BASE}/${id}`, patch);
    return data;
  },

  async syncNow(): Promise<void> {
    await apiClient.post(`${BASE}/sync`);
  },

  async setupPinterest(): Promise<void> {
    await apiClient.post(`${BASE}/pinterest/setup`);
  },

  /** Downloads the filtered leads as CSV through the authenticated client. */
  async exportCsv(filters: LeadFilters): Promise<void> {
    const response = await apiClient.get(`${BASE}/export`, { params: filters, responseType: 'blob' });
    const url = URL.createObjectURL(response.data);
    const a = document.createElement('a');
    a.href = url;
    a.download = `admeru-leads-${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  },
};
